import * as Cookies from 'js-cookie';
export default class CookieStorage {
  constructor(data) {
    const {
      domain,
      path,
      expires,
      secure,
      sameSite
    } = data || {};
    this.domain = domain;
    this.path = path || '/';
    this.expires = expires || 365;
    this.secure = secure || false;
    if (this.sameSite) {
      this.sameSite = sameSite;
    }
  }
  async setItem(key, value) {
    const options = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    if (this.sameSite) {
      options.sameSite = this.sameSite;
    }
    Cookies.set(key, value, options);
    return Cookies.get(key);
  }
  async getItem(key) {
    return Cookies.get(key);
  }
  async removeItem(key) {
    const options = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    if (this.sameSite) {
      options.sameSite = this.sameSite;
    }
    return Cookies.remove(key, options);
  }
  async clear() {
    const cookies = Cookies.get();
    let index;
    for (index = 0; index < cookies.length; ++index) {
      Cookies.remove(cookies[index]);
    }
    return {};
  }
}